import React, { Component } from 'react'
import { useMediaQuery } from 'react-responsive'

const Card = () => {
  let isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div className="flip-card">
            <div className="flip-card-inner">
                <div className="flip-card-front">
                    <h1 className="flip-card-front-content">I'm a Bioengineer turned software developer with a passion for technology and programming.</h1>  
                    {/* <p>.</p>               */}
                    <img src="https://img.icons8.com/wired/64/000000/circled.png"/>
                    <h1 class="clickMe"> ({isMobile? "click me" : "hover here"})</h1>

                    </div>
                <div className="flip-card-back">
                    <div className="flip-card-front-content">

                        <p>My Thesis:</p>
                        <p>Multi-physics modelling of cardiac perfusion</p> 
                        <p>&</p> 
                        
                        
                        <a target="_blank" href="https://www.researchgate.net/publication/334480842_16_Assessing_the_accuracy_of_a_novel_in_silico_imaging_tool_for_the_3D_reconstruction_of_coronary_vasculature_in_the_context_of_virtual_fractional_flow_reserve"><p>A Publication I participated in</p></a>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    )
}

export default Card
